"use strict";import r from"./src/spectrum-base.css.js";import o from"./src/spectrum-lang.css.js";import t from"./src/lang-overrides.css.js";import s from"./src/spectrum-heading.css.js";import m from"./src/heading-overrides.css.js";import{css as e}from"lit";const i=e`
    ${o}
    ${t}
`,a=e`
    ${s}
    ${m}
`;export default[r,i,a];
//# sourceMappingURL=heading.js.map
